import { render, staticRenderFns } from "./orderDescription.vue?vue&type=template&id=2c9d51e8&scoped=true&"
import script from "./orderDescription.vue?vue&type=script&lang=js&"
export * from "./orderDescription.vue?vue&type=script&lang=js&"
import style0 from "./orderDescription.vue?vue&type=style&index=0&id=2c9d51e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d51e8",
  null
  
)

export default component.exports